import { createModel } from '@rematch/core';

type DialogState = {
  openDialog: string;
};

const setOpenDialog = function handleSetOpenDialog(
  state: DialogState,
  dialog: string
): DialogState {
  return {
    ...state,
    openDialog: dialog
  };
};

const dialog = createModel({
  state: {
    openDialog: ''
  },
  reducers: {
    setOpenDialog
  }
});

export default dialog;
